import { VCard } from 'vuetify/lib/components/VCard';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"card-value-subtitle-component"}},[_c(VCard,{staticClass:"rounded-xl shadow-md pa-4"},[_c('p',{staticClass:"mb-0 font-weight-bold font-16 text-skin-default"},[_vm._v(_vm._s(_vm.value))]),_c('p',{staticClass:"mb-0 font-14 text-skin-medium"},[_vm._v(_vm._s(_vm.subtitle))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }